import{getTokenType as getTokenTypeName}from"wild-wild-parser";






const recurse=(queryArray,index)=>{
const parentQuery=queryArray.slice(0,index);
const lastIndex=getLastIndex(queryArray,index);
return[
[...parentQuery,...queryArray.slice(lastIndex+1)],
[...parentQuery,{type:"any"},...queryArray.slice(lastIndex)]]

};


const getLastIndex=(queryArray,index)=>
index<=queryArray.length-1&&
getTokenTypeName(queryArray[index])==="anyDeep"?
getLastIndex(queryArray,index+1):
index-1;

export const ANY_DEEP_TOKEN={
name:"anyDeep",
array:false,
recurse
};